import React from 'react';

import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { Job } from '@libs/graphql-types';

import { JobAccordion } from './JobAccordion';

const useStyles = makeStyles((theme: any) => ({
  label: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    marginBottom: theme.spacing(0.5),
  },
  value: {
    fontSize: '0.875rem',
    fontWeight: 500,
  },
}));

interface SystemInfoAccordionProps {
  jobData: Job;
  expanded?: boolean;
  onChange?: (expanded: boolean) => void;
}

export const SystemInfoAccordion: React.FC<SystemInfoAccordionProps> = ({
  jobData,
  expanded,
  onChange,
}) => {
  const classes = useStyles();

  // Use actual data from striive job schema
  const striive_job = jobData.striive_job;
  const getValue = (val: any) =>
    val !== undefined && val !== null && val !== '' ? val : '-';
  const formatDateTime = (date: any) => {
    if (!date) return '-';
    const d = new Date(date);
    return `${d.toLocaleDateString()}, ${d.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    })}`;
  };

  const mappedData = {
    createdBy:
      striive_job && striive_job.coordinator_full_name && striive_job.created_at
        ? `${getValue(striive_job.coordinator_full_name)} ${formatDateTime(
            striive_job.created_at,
          )}`
        : '-',
    lastModifiedBy:
      striive_job && striive_job.distributor_full_name && striive_job.updated_at
        ? `${getValue(striive_job.distributor_full_name)} ${formatDateTime(
            striive_job.updated_at,
          )}`
        : '-',
  };

  const renderDetailItem = (label: string, value: string | number) => (
    <Grid item xs={12} sm={6}>
      <Typography className={classes.label}>{label}</Typography>
      <Typography className={classes.value}>{value}</Typography>
    </Grid>
  );

  return (
    <JobAccordion
      title="SYSTEM INFORMATION"
      expanded={expanded}
      onChange={onChange}
    >
      <Grid container spacing={3}>
        {renderDetailItem('Created By:', mappedData.createdBy)}
        {renderDetailItem('Last Modified By:', mappedData.lastModifiedBy)}
      </Grid>
    </JobAccordion>
  );
};
